/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { randomUniform } from 'd3-random'
import { line } from 'd3-shape'
import filter from 'lodash/filter'
import CalculateHitLocation from '../../Utilities/CalculateHitLocation'
import { RemoveBadSprayPoints } from '../../Utilities/RemoveBadPoints'
import Color from '../../Utilities/Colors/ColorMap'
import Legend from '../../Legend/Legend'
import Tooltip from '../../Tooltip/Tooltip'
import TooltipHtml from '../../Tooltip/Html/SingleEvent'

import RadialBackgroundSVG from '../Helpers/RadialVisual'

export default function Radial({ settings, chartOptions = {} }) {
    // Remove null spray
    const sprayData = settings.data

    const angleMin = -80
    const angleMax = 80
    const angle = randomUniform(angleMin, angleMax)
    const veloMin = 20
    const veloMax = 120
    const originX = 124
    const originY = 292
    const radius = 270
    const xscale = scaleLinear()
        .domain([0, 1])
        .range([originX, originX + radius])
    const yscale = scaleLinear()
        .domain([-1, 1])
        .range([originY - radius, originY + radius])

    const toRadians = function (deg) {
        return (-Math.PI * deg) / 180
    }

    const toX = function (d) {
        const vnorm = parseFloat(d.launchSpeed) / veloMax
        const theta = toRadians(parseFloat(d.launchAngle))
        return vnorm * Math.cos(theta)
    }

    const toY = function (d) {
        const vnorm = parseFloat(d.launchSpeed) / veloMax
        const theta = toRadians(parseFloat(d.launchAngle))

        return vnorm * Math.sin(theta)
    }

    const lineDegree = line()
        .x((d) => xscale(toX(d)))
        .y((d) => yscale(toY(d)))

    const keyLines = [
        [
            { launchSpeed: 0, launchAngle: 0 },
            { launchSpeed: 120, launchAngle: 0 },
        ],
        [
            { launchSpeed: 0, launchAngle: 0 },
            { launchSpeed: 120, launchAngle: 45 },
        ],
    ]

    const keyText = [
        { launchSpeed: 123, launchAngle: 51, text: '120 MPH' },
        { launchSpeed: 123, launchAngle: 45, text: '45 °' },
        { launchSpeed: 123, launchAngle: -1, text: '0 °' },
        { launchSpeed: 123, launchAngle: 90, text: '120 MPH' },
        { launchSpeed: 126, launchAngle: -90, text: '120 MPH' },
        { launchSpeed: 114, launchAngle: 90, text: '90 °' },
        { launchSpeed: 117, launchAngle: -90, text: '-90 °' },
    ]

    function handleMouseOver(event, tip) {
        Tooltip(event, settings, tip)
    }

    function handleMouseOut(event) {
        Tooltip(event, settings)
    }

    return (
        <>
            <g>
                <svg
                    width={settings.vizWidth}
                    height={settings.vizHeight}
                    viewBox={[0, 0, 600, 600]}
                    id="radial"
                    dangerouslySetInnerHTML={{ __html: RadialBackgroundSVG }}
                />
                <svg
                    width={settings.vizWidth}
                    height={settings.vizHeight}
                    viewBox={[0, 0, 600, 600]}
                    id="radial"
                >
                    <g>
                        {sprayData.map((d, i) => (
                            <circle
                                key={`radial_circle_${i}`}
                                cx={xscale(toX(d))}
                                cy={yscale(toY(d))}
                                r={7}
                                fill={Color('paResult', d.paResult)}
                                stroke="#000"
                                strokeWidth={0.5}
                                onMouseOver={(event) => {
                                    const html = d.tooltip

                                    if (html) {
                                        handleMouseOver(event, html)
                                    }
                                }}
                                onMouseOut={(event) => {
                                    handleMouseOut(event, d)
                                }}
                                onClick={() => {
                                    if (d.videoUrl) {
                                        window.open(d.videoUrl)
                                    }
                                }}
                            />
                        ))}

                        {keyLines.map((d, i) => (
                            <path
                                key={`radial_lines_${i}`}
                                d={lineDegree(d)}
                                stroke="#b2b2b2"
                                strokeWidth={2}
                                fill="none"
                            />
                        ))}
                        {keyText.map((d, i) => (
                            <text
                                key={`radial_text_${i}`}
                                x={xscale(toX(d))}
                                y={yscale(toY(d))}
                                style={{ fontSize: '14px' }}
                            >
                                {d.text}
                            </text>
                        ))}
                    </g>
                </svg>
            </g>
            <Legend settings={settings} type="paResult" />
        </>
    )
}
